import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';
import { asyncConnect } from 'redux-connect';

import { isLoaded as areModulesLoaded, load as loadModules } from 'redux/modules/modules';
import { ComClientForm } from 'components';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    const promises = [];
    if (!areModulesLoaded(getState())) {
      promises.push(dispatch(loadModules()));
    }
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    modules: state.modules.data,
  })
)
@translate(['common'])
export default class AddClientPage extends Component {

  render() {

    const {t} = this.props

    return (
      <div className={'container'}>
        <Helmet title={t('main.create_client')} />
        <h1>{t('main.create_client')}</h1>

        <ComClientForm key="createClientForm1" initialValues={{ hyperUser: { etat: 1 } }} />
      </div>
    );
  }
}
